import { defineComponent, h, ref } from "vue";
import { useRepositories } from "@/infra/api/injects";
import { LocalizationError } from "@/error/error";
import { CommunicationState } from "@/type";

export interface PasswordResetRequestArgs {
  email: string;
}

const PasswordResetRequestContainer = (WrappedComponent: any) =>
  defineComponent({
    name: "PasswordResetRequestContainer",
    setup() {
      const error = ref<LocalizationError | null>(null);
      const successMessage = ref<string>("");
      const communicationState = ref<CommunicationState>(1);
      const repositories = useRepositories();

      async function requestPasswordReset(req: PasswordResetRequestArgs): Promise<void> {
        try {
          error.value = null;
          successMessage.value = "";
          communicationState.value = 2;

          const message = await repositories.value.PasswordResetRepository.requestPasswordReset({
            email: req.email,
          });

          successMessage.value = message || "パスワードリセット用のメールを送信しました。\nこの画面を閉じ、メールをご確認ください。\n迷惑メールに入る可能性もございますので、ご注意ください。";
        } catch (e) {
          if (e instanceof LocalizationError) {
            error.value = e;
          }
        } finally {
          communicationState.value = 1;
        }
      }

      return {
        requestPasswordReset,
        error,
        successMessage,
        communicationState,
      };
    },
    render() {
      return h(WrappedComponent, {
        communicationState: this.communicationState,
        localizationError: this.error,
        successMessage: this.successMessage,
        onRequestPasswordReset: (request: PasswordResetRequestArgs) => this.requestPasswordReset(request),
      });
    },
  });

export default PasswordResetRequestContainer;
